import React, { useEffect, useState } from "react";
import Table from "../ui/VirtualTable";
import Float from "../ui/Float";
import { areAll, bm_date, emptyObj, getRowClass, setAll } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import Space from "../ui/Space";
import { SortIcon } from "../utils/Icons";
import Button from "../ui/Button";
import Checkbox from "../ui/Checkbox";
import Divider from "../ui/Divider";
import dayjs from "dayjs";
import Nav from "../ui/Nav";
import { KBD } from "../utils/Keybindings";
import HistoryFilters from "../popups/HistoryFilters";
import { createModal } from "../hooks/createModal";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import ModalButton from "../ui/ModalButton";
import Spin from "../ui/Spin";

function InventoryHistory(props) {

    const { controller = "", selected = {}, switchView = () => { }, view = "", route = "", history = { rows: [], total: 0 }, show_expand = true, onHistorySelect = () => {}, filters, setFilters } = props;

    const [data, setData] = useState(history);
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState({});
    const row_key = "history_id";
    const min = (view === "history") ? false : true;
    const limit = 40;


    useEffect(() => {
        if (min) {
            if (data?.rows.length > 0) {
                setCurrent(data?.rows[0]);
            } else {
                setCurrent({});
            }
        }
    }, [min])


    useEffect(() => onHistorySelect(current), [current])


    const showHistoryFilters = () => {
        window.bm_state.value = ROUTES.HISTORY.FILTERS;
        createModal({
            component: <HistoryFilters controller={controller} filters={filters} route={ROUTES.HISTORY.FILTERS} />, closable: true, title: <>History Filters</>, callback: (_filter) => {
                if (_filter) {
                    setFilters({ ..._filter })
                }
                window.bm_state.value = route;
            }
        })
    }

    const history_nav = [
        { key: KBD.ESCAPE, action: () => switchView() },
        { key: KBD.ARROW_LEFT, action: () => switchView() },
        { text: "A/R" },
        { text: "Del" },
        { text: "Edt" },
        { key: KBD.ALT_E, text: "@Edt", action: () => { console.log("Alt+E pressed") } },
        { key: KBD.H, text: "Hst", action: () => showHistoryFilters() },
        { text: "Ord" },
        { text: "Prt" },
        { text: "Rsv" },
        { text: "Total" },
        { key: KBD.V, text: "View", action: () => switchView() },

    ]

    useEffect(() => {
        if (loading || props.loading) {
            return;
        }
        const cleanup = listen(controller, ROUTES.CUSTOMER.HISTORY, history_nav);
        return cleanup;
    }, [history_nav, loading, props.loading])

    const columns = [
        { min: true, key: "status", align: "left", title: <>Type</>, width: (min) ? 35 : 48 },
        {
            min: false, key: "display_date", align: "left", title: <>Date</>, width: 90, render: (e) => {
                return (e) ? dayjs(e).format("MMMDD-YY") : "";
            }
        },
        { min: true, key: "quantity", title: <>Qty</>, grow: false, width: (min) ? 30 : 31 },
        { min: true, key: "price", title: <>Price</>, grow: false, width: 74 },
        { min: true, key: "discount", title: <>%</>, grow: false, width: 30 },
        { min: false, key: "title", title: <>Title</>, grow: true, width: 30 },
        { min: true, key: "custpo", align: "left", grow: false, title: <>CustPO#</>, width: (min) ? 85 : 105 },
        { min: false, key: "invoice", title: <>Invoice#</>, grow: false, width: 75 },
        { min: true, key: "supplier", align: "left", title: <>Supp</>, grow: false, width: 64 },
        { min: true, key: "order_retno", title: <>Order#</>, grow: false, width: 64 },
        { min: false, key: "invoice_date", title: <>ODate#</>, width: 90, render: (e) => { return <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span> } },
        { min: false, key: "primary_code", title: <>ISBN</>, grow: false, width: 160 },
    ]


    const drawFilters = () => {

        if (min) {
            return (<></>)
        } else {
            return (
                <Space size={16}>
                    <Checkbox value={areAll(filters, true)} onChange={(e) => {
                        if (areAll(filters, true)) {
                            // set to none
                            let _all_removed = setAll(filters, false);
                            setFilters({ ..._all_removed });
                            return;
                        } else {
                            let _all_added = setAll(filters, true);
                            setFilters({ ..._all_added });
                            return;
                        }
                    }} >Complete</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "a_r": e })} value={filters.a_r}>A/R</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "held": e })} value={filters.held}>Held</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "sales": e })} value={filters.sales}>Sales</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "invoices": e })} value={filters.invoices}>Invoices</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "prepay": e })} value={filters.prepay}>Prepay</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "orders": e })} value={filters.orders}>Orders</Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "quotes": e })} value={filters.quotes}>Quotes</Checkbox>
                </Space>
            )
        }
    }


    const drawHeader = () => {
        return (
            <div style={{ "padding": "0px 5px", "fontSize": "14px", "lineHeight": "17px" }}>
                <Float>
                    <div>Customer History</div>
                    <div>
                        <Space size={12}>
                            {(min && show_expand && <em><a onClick={() => switchView("history")}>← View details</a></em>)}
                            {drawFilters()}
                            {(!min &&
                                <Space>
                                    <div className="border-secondary-bg" style={{ "display": "block", "width": ".5px", "height": "30px", "marginTop": "-12px", "marginBottom": "-12px" }}></div>
                                    <ModalButton onClick={() => switchView()} style={{ "marginRight": "-3px" }} value={<>&times;</>} />
                                </Space>
                            )}
                        </Space>
                    </div>
                </Float>
            </div>
        )
    }

    const fetchHistory = (append = false) => {

        if (!selected?.ship_to) { return; }
        let _params = { ...filters };
        // Not used for now...
        _params.ship_to = selected.ship_to;
        _params.only_recent = false;
        _params.limit = limit;

        if (append) {
            _params.offset = data?.rows?.length || 0;

        } else {
            _params.offset = 0;
        }

        setLoading(true);
        pubCall("history.getCustomerAll", _params, (_s, _r) => {

            setLoading(false);
            if (_s) {

                setData(prev => {
                    if (append && prev?.rows?.length) {
                        return {
                            ..._r,
                            rows: [...prev.rows, ..._r.rows]
                        };
                    } else {
                        return _r;
                    }
                });

                if (_r?.rows.length > 0) {
                    setCurrent(_r?.rows[0]);
                } else {
                    setCurrent({});
                }

            }
        })
    }


    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            fetchHistory();
        }, 300);

        return () => clearTimeout(debounceTimer);
    }, [selected, filters])

    useEffect(() => {
        if (!current?.[row_key] || !data?.rows?.length || loading) return;
        const index = data.rows.findIndex(item => item?.[row_key] === current?.[row_key]);
        const buffer = 4;
        if (data.rows.length < data.total && index >= data.rows.length - buffer) {
            fetchHistory(true);
        }
    }, [current, data.rows]);

    const next = (_rows = 1) => {
        const d = data?.rows || [];
        if (d.length === 0) { setCurrent({}); return; }
        const nextIndex = d.findIndex(item => item?.[row_key] === current?.[row_key]) + _rows;
        if (d.length <= nextIndex) { setCurrent(d[d.length - 1]); }
        if (nextIndex < d.length) { setCurrent(d[nextIndex]); }
    };

    const prev = (_rows = 1) => {
        const d = data?.rows || [];
        if (d.length === 0) { setCurrent({}); return; }
        const prevIndex = d.findIndex(item => item?.[row_key] === current?.[row_key]) - _rows;
        if (prevIndex < 0) { setCurrent(d[0]); }
        if (prevIndex >= 0) { setCurrent(d[prevIndex]); }
    };

    const ind = data?.rows.findIndex(item => item?.[row_key] === current?.[row_key]) || 0;

    return (<Spin loading={loading}>
        <Space size={0}>
            {(!min && <div onClick={() => switchView()} style={{ "width": "0px" }} className="ui-swap-btn">
                <div style={{ "position": "absolute", "zIndex": "1", "backgroundColor": "#ffffff11", "height": "100px", "display": "block", "width": "12px", "marginRight": "14px" }}></div>
                <div style={{ "transform": "rotate(-90deg)", "marginRight": "19px" }}>
                    <SortIcon />
                </div></div>)}
            <div>
                <Table
                    controller={controller}
                    small={(min) ? true : false}
                    offset={430}
                    row_key={row_key}
                    tweak={59}
                    next={next}
                    route={route}
                    prev={prev}
                    style={{ "transition": "width 220ms cubic-bezier(0.2, 0.9, 0.3, 1)" }}
                    current={(min) ? {} : current}
                    onRowClick={(e) => setCurrent(e)}
                    height={252}
                    columns={(min) ? columns.filter(item => item.min) : columns}
                    data={data?.rows || []}
                    width={(min) ? 433 : 1000}
                    rowClass={getRowClass}
                    header={drawHeader()}
                />
            </div>
        </Space>
        {(!min && <div style={{ "marginLeft": "0px", "position": "absolute", "marginTop": "17px" }}><Nav nav={history_nav} /></div>)}
    </Spin>
    )
}

export default React.memo(InventoryHistory)